<template>
    <footer class="footer">
        <div class="footer__wrapper">
            <div class="footer__logo">
                <img src="@/assets/svg/merck.svg" alt class="footer__logo"/>
            </div>
            <nav class="footer__nav">
                <a href="/racer-instrukcja-konsultant.pdf" target="_blank" class="footer__link" v-if="userData.is_consultant">
                    <IconInfo/> Instrukcja
                </a>
                <a href="/racer-instrukcja-lekarz.pdf" target="_blank" class="footer__link" v-if="userData.is_doctor">
                    <IconInfo/> Instrukcja
                </a>
                <span class="footer__separator" v-if="userData.is_consultant || userData.is_doctor || userData.is_admin">|</span>
                <a href="/racer-wymagania-sprzetowe.pdf" target="_blank" class="footer__link">
                    <IconLaptopPhone/> Wymagania sprzętowe
                </a>
                <span class="footer__separator">|</span>
                <router-link to="/bledy-i-sugestie" class="footer__link">
                    <IconChatPlus/> Błędy i sugestie
                </router-link>
                <span class="footer__separator">|</span>
                <router-link to="/regulamin" class="footer__link">Regulamin</router-link>
                <span class="footer__separator">|</span>
                <router-link to="/polityka-prywatnosci" class="footer__link">Polityka prywatności</router-link>
            </nav>
        </div>
    </footer>
</template>
<script>

import {IconChatPlus, IconLaptopPhone, IconInfo} from './ui/icons'
import {mapGetters} from "vuex";

export default {
    name: "Footer",
    components: {
        IconChatPlus,
        IconLaptopPhone,
        IconInfo,
    },
    computed: mapGetters({
        userData: "getUserData",
    }),
};
</script>

<style lang="scss">
.footer {
    $this: &;
    height: 160px;
    background: linear-gradient(to right, #1ea3ad, #50aa66, #85b904);
    padding: 1px 0 0;
    position: relative;

    &:after {
        content: " ";
        right: 0;
        width: 50%;
        height: calc(100% - 61px);
        background: #f1f1f1;
        position: absolute;
        top: 61px;
    }

    &__wrapper {
        width: 95%;
        max-width: 1140px;
        margin: 60px auto 0;
        min-height: 100px;
        background: #f1f1f1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        z-index: 1;
        border-radius: 50px 0 0 0;
        @include media-breakpoint-down(md) {
            flex-wrap: wrap;
            justify-content: center;
        }

        #{$this}__logo {
            height: 20px;
            object-fit: scale-down;
            margin: 0 60px;
            display: block;
        }

        #{$this}__link {
            color: #000000;
            font-size: 12px;

            svg {
                margin: 2px 5px -2px 0;
                color: #158491;
            }
        }

        #{$this}__separator {
            font-size: 12px;
            margin: 0 10px;
        }
    }
}
</style>
